import React from "react";
import { pageTitle } from "../../config/page-settings";

class Footer extends React.Component {
  constructor (props) {
    super(props);

    const date = new Date();
    this.state = {
      year: date.getFullYear(),
    };
  }

  render () {
    return (
      <div id="footer" className="footer">&copy; { this.state.year } { pageTitle }的工作小站 - All Rights Reserved</div>
    );
  }
}

export default Footer;
